<template>
    <div>
        <a @click="check" class="cursor-pointer">
            <slot>IM A BUTTON</slot>
        </a>

        <portal to="dialog" v-if="showModal">
            <modal @close="showModal = false">

                <template slot="header">
                    <slot name="header">slot::header</slot>
                </template>

                <div class="mb-16">
                    <slot name="question">Möchtest du wirklich?</slot>
                </div>

                <div class="grid grid-flow-col">
                    <div class="flex justify-end">
                        <button-primary @click="confirm()">
                            <slot name="confirm">CONFIRM</slot>
                        </button-primary>
                    </div>

                    <div v-if="hasCancelSlot" class="flex justify-end">
                        <button-delete @click="cancel()">
                            <slot name="cancel">CANCEL</slot>
                        </button-delete>
                    </div>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./ButtonPrimary";
import Modal from "../Modal";
import ButtonDelete from "./ButtonDelete.vue";

export default {
    name: "ConfirmDialog",
    components: {ButtonDelete, ButtonPrimary, Modal},
    props: {
        needConfirmation: {
            type: Boolean,
            default: true,
        },
    },

    data: () => ({
        showModal: false,
    }),

    computed: {
        hasCancelSlot() {
            return !!this.$slots.cancel;
        },
    },

    methods: {
        check() {
            if (!this.needConfirmation) {
                return this.confirm();
            }

            this.showModal = true;
        },
        confirm() {
            this.showModal = false;
            this.$emit('confirmed');
        },
        cancel() {
            this.showModal = false;
            this.$emit('canceled');
        },
    },
}
</script>

<style scoped>

</style>
